import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[dsFormFieldEvents]',
})
export class FormFieldEventsDirective {
  public inputEvent = output<Event>();
  public changeEvent = output<Event>();
  public blurEvent = output<Event>();

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    this.inputEvent.emit(e);
  }

  @HostListener('change', ['$event'])
  onChange(e: Event) {
    this.changeEvent.emit(e);
  }

  @HostListener('blur', ['$event'])
  onBlur(e: Event) {
    this.blurEvent.emit(e);
  }
}
